// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Text } from '../../../../../atoms';
import { useOpenedIncomingPayment, getSafeCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment';
import { getCreditCardCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment/checkout-payment-options';
import amexImageSrc from '../fields/card-icon/images/card-amex.svg';
import visaImageSrc from '../fields/card-icon/images/card-visa.svg';
import mastercardImageSrc from '../fields/card-icon/images/card-mastercard.svg';
import dinersImageSrc from '../fields/card-icon/images/card-diners.svg';
import discoverImageSrc from '../fields/card-icon/images/card-discover.svg';
import bancardCheckImageSrc from '../fields/card-icon/images/card-bancard-check.svg';
import credifielcoImageSrc from '../fields/card-icon/images/card-credifielco.svg';
import infonetImageSrc from '../fields/card-icon/images/card-infonet.svg';
import jcbImageSrc from '../fields/card-icon/images/card-jcb.svg';
import eloImageSrc from '../fields/card-icon/images/card-elo.svg';
import unionpayImageSrc from '../fields/card-icon/images/card-unionpay.svg';

export function DisplayParaguayanCreditcardBanksInfo(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);
  const creditCardAllowedBrands = getCreditCardCheckoutPaymentOptions(checkoutPaymentOptions);

  return (
    <CreditCardBanksInfo data-test-id="paraguayan-creditcard-banks-info">
      <Text flavor="secondary">Tarjetas de crédito aceptadas</Text>

      <CreditCardBrands>
        {creditCardAllowedBrands.map(brand => (
          <CardBrandImageWrapper key={brand}>
            <CardBrandImage alt={brand} src={getCardBrandImageSrc(brand)} />
          </CardBrandImageWrapper>
        ))}
      </CreditCardBrands>
    </CreditCardBanksInfo>
  );
}

const CreditCardBanksInfo = styled.div`
  font-size: ${props => props.theme.fontSize};
  color: ${props => props.theme.colors.secondary('32')};
  font-family: ${props => props.theme.fontFamily.sansSerif};
`;

const CreditCardBrands = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  width: 100%;
  margin: 10px 0 14px 0;
`;

const CardBrandImageWrapper = styled.div`
  height: 20px;
  margin-right: 6px;
  margin-bottom: 6px;
`;

const CardBrandImage = styled.img`
  height: 100%;
  width: 100%;
`;

function getCardBrandImageSrc(cardBrand: string): string {
  switch (cardBrand) {
    case 'amex':
      return amexImageSrc;
    case 'visa':
      return visaImageSrc;
    case 'mastercard':
      return mastercardImageSrc;
    case 'elo':
      return eloImageSrc;
    case 'diners':
      return dinersImageSrc;
    case 'bancard-check':
      return bancardCheckImageSrc;
    case 'discover':
      return discoverImageSrc;
    case 'credifielco':
      return credifielcoImageSrc;
    case 'infonet':
      return infonetImageSrc;
    case 'jcb':
      return jcbImageSrc;
    case 'unionpay':
      return unionpayImageSrc;
    default:
      return '';
  }
}
